import { ReactComponent as AddIcon } from "@src/styles/icon/add.svg";
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import Loading from "../../../component/Desktop/loading/loading";
import TitlePage from "../../../component/Desktop/titlePage";
import {
  COMMON_CONSTANT,
  CONFIG,
  DISASTER_STATUS,
  KEY,
  lang,
  STYLE,
} from "../../../constants/common.const";
import {
  getQuerySearch,
  getTxtValue,
  handleCatchError,
  isAdminOffice,
  pushObject2Query,
  pushObject2QueryReplace,
  renderOption,
  showMessage,
} from "../../../constants/utils";

import classGrid from "../../../models/control/grid";
import classText from "../../../models/control/text";

import RoleConst from "@src/routers/roles/roles.const";

import {
  ClearOutlined,
  DeleteOutlined,
  EditFilled,
  SearchOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import Paragraph from "antd/lib/typography/Paragraph";
import { useMediaQuery } from "react-responsive";
import { ApiDisaster } from "../../../api/backend/disaster";
import kbn from "../../../api/backend/kbn";
import BoxContent from "../../../component/Desktop/content";
import routerConst from "../../../constants/router.const";
import statusConst from "../../../constants/status.const";
import classDdl from "../../../models/control/dropdownlist";
import rolesConst from "../../../routers/roles/roles.const";

function Disaster_List() {
  const { selectedFactory, roles } = useSelector((state) => state.auth);

  // check role
  const isOfficeAdmin = roles == rolesConst.OFFICE_ADMIN;
  const isRoleCanAction = roles == rolesConst.HEAD_OFFICE_ADMIN || roles == rolesConst.OFFICE_ADMIN ||  roles == rolesConst.OFFICE_USER

  const objSearch = getQuerySearch();

  const isPC = useMediaQuery({
    query: KEY.LAPTOP_WIDTH,
  });

  const { allowRoute } = useSelector((state) => state.auth);
  const location = useLocation();
  const history = useHistory();
  // Loading
  const [showLoading, setShowLoading] = useState(false);
  let openLoadingSpinner = () => {
    setShowLoading(true);
  };
  let closeLoadingSpinner = () => {
    setShowLoading(false);
  };
  const [formSearch] = Form.useForm();

  //  Grid
  const [grid, setGrid] = useState(new classGrid());
  // Input search
  // Group 1
  // 1
  const [txtName, setTxtName] = useState({
    ...new classText(),
    value: getTxtValue(objSearch.name),
  });

  let [ddlCategory, setddlCategory] = useState({
    ...new classDdl(),
    value: objSearch.category ? Number(objSearch.category) : null,
  });
  const [ddlFactory, setddlFactory] = useState({
    ...new classDdl(),
    value: isRoleCanAction ? getTxtValue(objSearch.factory) : selectedFactory,
  });

  const objColorStatus = {};
  statusConst.STATUS_DISASTER.forEach((v) => {
    objColorStatus[v.key] = v.color;
    objColorStatus[v.value] = v.color;
  });
  const [currentPage, setCurrentPage] = useState(objSearch.page || 1);

  // Search
  const search_onClick = async (init = true) => {
    try {
      setShowLoading(true);
      const response = await ApiDisaster.searchDisaster({
        siteOfficeMasterCode: ddlFactory.value,
        name: txtName.value ? txtName.value.trim() : null,
        categoryId: ddlCategory.value,
      });
      setGrid({ ...grid, data: response.data, count: response.data.length });
      if (!init) {
        setCurrentPage(1);
        pushObject2Query({
          name: txtName.value,
          category: ddlCategory.value,
          factory: ddlFactory.value,
          page: 1,
        });
      } else {
        pushObject2Query({
          name: txtName.value,
          category: ddlCategory.value,
          factory: ddlFactory.value,
          page: currentPage,
        });
      }
    } catch (error) {
      handleCatchError(error);
    } finally {
      setShowLoading(false);
    }
  };

  // clearInputSearch
  const clearInputSearch = () => {
    setTxtName({ ...txtName, value: null });
    setddlCategory({ ...ddlCategory, value: null });
    setddlFactory({ ...ddlFactory, value: null });
    formSearch.resetFields();
    formSearch.submit();
  };

  const getStatusValue = (status) => {
    const statusCurrent = statusConst.STATUS_DISASTER.find(
      (i) => i.key == status
    );
    if (statusCurrent) {
      return statusCurrent;
    }
    return {};
  };

  // INIT DATA
  // detail
  const getInitData = async () => {
    try {
      const [categoryRes, officeRes] = await Promise.all([
        ApiDisaster.searchCategory(),
        kbn.getSiteOffice(),
      ]);
      setddlCategory({ ...ddlCategory, options: categoryRes.data });
      setddlFactory({ ...ddlFactory, options: officeRes.data.data });
    } catch (error) {
      handleCatchError(error);
    }
  };
  // Init data
  useEffect(() => {
    getInitData();
  }, []);
  // Column GRID
  const initColumns = [
    {
      title: lang.ID,
      dataIndex: "id",
      width: "10%",
      align: "center",
    },
    {
      title: (
        <div style={{ textAlign: "left", paddingLeft: 10 }}>
          {lang.DISASTER_NAME}
        </div>
      ),
      width: "30%",
      align: "start",
      render: (text, row) => {
        const currentStatus = getStatusValue(row.status);

        return (
          <Tooltip trigger={["hover"]} title={row.name}>
            <span
              className="underline"
              style={{ color: currentStatus.color }}
              onClick={() =>
                history.push(
                  `${routerConst.ROUTER_PAGE.DISASTER_LIST[3]}/${row.id}`
                )
              }
            >
              {"【"}
              {row.siteOfficeMasterName}
              {"】"}
              {row.name}
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: lang.DISASTER_CATEGORY,
      dataIndex: "category",
      width: isRoleCanAction ? "15%" : "20%",
      align: "center",
    },
    {
      title: lang.STATUS,
      dataIndex: "status",
      align: "center",
      width: "15%",
      render: (_, v) => {
        const currentStatus = getStatusValue(v.status);
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            {" "}
            <Paragraph
              ellipsis={{ rows: 1 }}
              className="textStatus"
              style={{
                color: currentStatus.color,
                background: currentStatus.color + "1A",
              }}
            >
              {v.statusValue}
            </Paragraph>
          </div>
        );
      },
    },
    {
      title: "作成日",
      dataIndex: "createDatetime",
      width: isRoleCanAction ? "15%" : "20%",
      align: "center",
    },
    {
      title: "更新日",
      dataIndex: "updateDatetime",
      width: isRoleCanAction ? "15%" : "20%",
      align: "center",
    },
  ];
  if (isRoleCanAction) {
    initColumns.push({
      title: lang.ACTION,
      align: "center",
      width: 180,
      render: (row,record) => {
        //
        return (
          <>
            {/* Edit */}
            <Tooltip title={lang.EDIT}>
              <Button disabled={record.status == DISASTER_STATUS.CLOSE} className="mr5 btnEdit">
                <Link
                  to={routerConst.ROUTER_PAGE.DISASTER_LIST[2] + "/" + row.id}
                  className="w100"
                >
                  <EditFilled className="" />
                </Link>
              </Button>
            </Tooltip>

            {/* Delete */}
            <Tooltip title={lang.DELETE}>
              <Button
                disabled={row.status != 1}
                className="mr5 btnDelete"
                onClick={() => {
                  showMessageDeleteConfirm(row);
                }}
              >
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </>
        );
      },
    });
  }

  const showMessageDeleteConfirm = (rowData) => {
    // Action del
    const funcDel = async () => {
      openLoadingSpinner();

      // API Del
      try {
        // Close warning
        Modal.destroyAll();

        await ApiDisaster.deleteDisaster(rowData.id);
        // API Search
        await search_onClick();

        // Open success
        showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C004);
      } catch (ex) {
        handleCatchError(ex);
      }
      closeLoadingSpinner();
    };

    Modal.confirm({
      icon: <QuestionCircleOutlined />,
      centered: true,
      title: lang.DELETE,
      content: "削除してもよろしいですか。",
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onOk: funcDel,
    });
  };

  useEffect(() => {
    search_onClick();
  }, []);

  useEffect(() => {
    if (!isRoleCanAction) {
      setddlFactory({ ...ddlFactory, value: selectedFactory });
    }
  }, [roles, selectedFactory]);
  // Render
  return (
    <div className="des-content">
      <TitlePage name={lang.DISASTER_LIST} />
      <BoxContent
        style={{
          margin: isPC ? "24px 16px" : 0,
          padding: isPC ? 24 : "0 16px",
        }}
      >
        <Form
          layout={"vertical"}
          name="searchWR"
          form={formSearch}
          onFinish={() => search_onClick(false)}
          className="formStyle"
        >
          {/* 1 */}
          <Row gutter={[16, 8]} align="bottom" className="rowNotMargin">
            <Col lg={8} md={12} xs={24}>
              <div className="ant-form-item-label">{lang.DISASTER_NAME}</div>
              <Input
                placeholder={lang.DISASTER_NAME}
                value={txtName.value}
                maxLength={255}
                onChange={(e) =>
                  setTxtName({
                    ...txtName,
                    value: e.target.value,
                  })
                }
              />
            </Col>
            <Col lg={8} md={12} xs={24}>
              <div className="ant-form-item-label">{lang.FACTORY_MAME}</div>
              <Select
                disabled={!isRoleCanAction}
                placeholder={lang.FACTORY_MAME}
                value={ddlFactory.value}
                className={
                  ddlFactory.error ? `${STYLE.BORDER_RED} w100` : "w100"
                }
                onChange={(v) => {
                  setddlFactory({ ...ddlFactory, value: v });
                }}
              >
                {renderOption(ddlFactory.options || [])}
              </Select>
            </Col>
            <Col lg={8} md={12} xs={24}>
              <div className="ant-form-item-label">
                {lang.DISASTER_CATEGORY}
              </div>
              <Select
                placeholder={lang.DISASTER_CATEGORY}
                value={ddlCategory.value}
                className={
                  ddlCategory.error ? `${STYLE.BORDER_RED} w100` : "w100"
                }
                onChange={(v) => {
                  setddlCategory({ ...ddlCategory, value: v });
                }}
              >
                {renderOption(ddlCategory.options)}
              </Select>
            </Col>
            <Col flex="auto"></Col>
            {/* Button Search/Clear */}
            <Col
              flex="none"
              className="right"
              style={isPC ? null : { padding: "8px 4px" }}
            >
              <Row className="rowNotMargin" gutter={[12, 12]} justify="end">
                <Col>
                  <Button
                    htmlType="submit"
                    className="buttonPC button--info wAuto"
                  >
                    <SearchOutlined className="" />
                    {lang.SEARCH}
                  </Button>
                </Col>
                <Col>
                  <Button
                    className="buttonPC button--outline --todo-- wAuto ml10"
                    onClick={clearInputSearch}
                  >
                    <ClearOutlined />
                    {lang.CLEAR}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </BoxContent>

      <BoxContent
        style={{
          margin: isPC ? "24px 16px" : 0,
          padding: isPC ? 24 : "12px 24px",
        }}
      >
        {/* Count */}
        <Row justify="space-between ">
          <Col span={12}>
            {isRoleCanAction && (
              <Button
                type="link"
                style={{
                  display:!isRoleCanAction ? "none" : "block",
                }}
                className="btnAddRecord mb15"
                onClick={() => {
                  history.push(routerConst.ROUTER_PAGE.DISASTER_LIST[1]);
                }}
              >
                <AddIcon />
                {lang.ADD}
              </Button>
            )}
          </Col>
          <Col span={12} className="right">
            {/* Count */}
            <Space size={10} align="center ">
              {lang.ACCESS_NUMBERS}
              <span>
                {grid.count}
                {lang.CASE}
              </span>
            </Space>
          </Col>
        </Row>
        {/* Grid  */}
        <Table
          rowKey={(record) => record.id}
          className="gridSearch "
          columns={initColumns}
          dataSource={grid.data}
          pagination={{
            ...CONFIG.paging,

            current: Number(currentPage) || 1,
            onChange: (curr) => {
              setCurrentPage(curr);
              pushObject2QueryReplace({ page: curr });
            },
          }}
        />
      </BoxContent>
      <Loading show={showLoading}></Loading>
    </div>
  );
}
export default Disaster_List;
